const resubmitOfferModalInitialState = {
  resubmitOfferModal: {
    isOpened: false,
    offerStage: '',
    offerId: '',
    offerDetail: {},
  },
}

const resubmitOfferModalReducer = {
  showResubmitOfferModal: (state, { payload }) => {
    state.resubmitOfferModal.isOpened = true
    state.resubmitOfferModal.offerStage = payload?.offerStage || ''
    state.resubmitOfferModal.offerId = payload?.offerId || ''
    state.resubmitOfferModal.offerDetail = payload?.offerDetail || {}
  },
  hideResubmitOfferModal: (state) => {
    state.resubmitOfferModal.isOpened = false
    state.resubmitOfferModal.offerStage = ''
    state.resubmitOfferModal.offerId = ''
    state.resubmitOfferModal.offerDetail = {}
  },
}

const selectResubmitOfferModal = (state) => state.offers.resubmitOfferModal

export { resubmitOfferModalInitialState, resubmitOfferModalReducer, selectResubmitOfferModal }
